import { i as b, E as x, x as r, a as n, r as g } from "./createReactComponent-58f9bea8.mjs";
import { n as i } from "./property-9daa16cd.mjs";
import { e as p } from "./class-map-2994e95e.mjs";
import { o as v } from "./style-map-c3339321.mjs";
import { r as m } from "./icon-button-a9d2a2d1.mjs";
import { r as w } from "./icon-c572aa57.mjs";
const u = b`
  /** LIGHT MODE */

  :host {
    width: 100%;
  }

  :host .pbl--wrapper {
    display: flex;
    gap: var(--exo-spacing-2x-small);
    flex-direction: column;
    width: fit-content;
  }

  :host .loader--container.loader--backdrop {
    opacity: var(--exo-opacity-0);
    z-index: var(--exo-z-index-dialog);
    background-color: var(--exo-color-scrim);
    border-radius: var(--exo-radius-large);
  }

  :host .loader--container.loader--inline {
    width: auto;
    height: auto;
    position: relative;
  }

  :host .loader--comp--container.loader--color--theme--dark .spinner {
    border-top: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action);
  }

  :host .loader--comp--container.loader--in--component-medium .spinner {
    width: var(--exo-spacing-standard);
    height: var(--exo-spacing-standard);
  }

  :host .loader--comp--container.loader--in--component-small .spinner {
    width: var(--exo-spacing-x-small);
    height: var(--exo-spacing-x-small);
  }

  :host .loader,
  :host .spinner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    flex-direction: column;
  }

  :host
    .loader--container
    .loader.loader--large
    .variant--default
    .loader--image {
    width: var(--exo-spacing-4x-large);
    height: var(--exo-spacing-4x-large);
  }

  :host
    .loader--container
    .loader.loader--medium
    .variant--default
    .loader--image,
  :host .loader--container .spinner.spinner__size-medium .spinner--loader {
    width: var(--exo-spacing-x-large);
    height: var(--exo-spacing-x-large);
  }

  :host
    .loader--container
    .loader.loader--small
    .variant--default
    .loader--image.spinner {
    width: var(--exo-spacing-x-small);
    height: var(--exo-spacing-x-small);
    border-width: var(--exo-spacing-3x-small);
  }

  :host
    .loader--container
    .loader.loader--default
    .variant--default
    .loader--image.spinner,
  :host .loader--container .spinner.spinner__size-x-small .spinner--loader {
    width: var(--exo-spacing-standard);
    height: var(--exo-spacing-standard);
    border-width: var(--exo-spacing-3x-small);
  }

  :host .loader.loader--large .variant--radar .loader--image {
    width: var(--exo-spacing-4x-large);
    height: var(--exo-spacing-4x-large);
  }

  :host .loader.loader--small .variant--radar .loader--image {
    width: var(--exo-spacing-x-large);
    height: var(--exo-spacing-x-large);
  }

  :host .loader .variant--radar .loader--image,
  :host .loader--container .spinner.spinner__size-large .spinner--loader {
    width: var(--exo-spacing-2x-large);
    height: var(--exo-spacing-2x-large);
  }

  :host .loader.loader--medium .variant--radar .loader--image {
    width: var(--exo-spacing-3x-large);
    height: var(--exo-spacing-3x-large);
  }

  :host .loader .loader__variant-spinner,
  :host .spinner .loader__variant-spinner {
    margin: var(--exo-spacing-x-large);
  }

  :host .spinner.spinner__size-large .loader--body {
    font: var(--exo-text-label-standard-semi-bold);
    line-height: calc(var(--exo-line-height-heading) * 1.2);
  }

  :host .loader--body {
    margin: var(--exo-spacing-none) var(--exo-spacing-x-large)
      var(--exo-spacing-x-large);
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font);
    display: block;
  }

  :host .loader svg {
    color: var(--exo-color-background-action);
  }

  :host .loader--comp--container .spinner {
    border-radius: var(--exo-radius-circle);
    border: var(--exo-spacing-3x-small) solid var(--exo-opacity-0);
    border-top: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-secondary);
    border-right: var(--exo-spacing-3x-small) solid var(--exo-opacity-0);
    animation: default-animation calc(var(--exo-time-x-slow)) linear infinite;
    box-sizing: border-box;
    margin: auto;
  }

  /** New Spinner**/

  :host .loader--container .spinner .spinner--loader.spinner {
    border-radius: var(--exo-radius-circle);
    border: var(--exo-spacing-3x-small) solid var(--exo-opacity-0);
    border-top-color: var(--exo-color-background-deselected);
    animation: default-animation calc(var(--exo-time-x-slow)) linear infinite;
    box-sizing: border-box;
    rotate: 45deg;
  }

  :host .loader--container .spinner.spinner__size-xx-small .spinner--loader {
    width: var(--exo-spacing-x-small);
    height: var(--exo-spacing-x-small);
    border-width: var(--exo-spacing-3x-small);
    border-right-color: var(--exo-color-background-deselected);
  }

  :host .loader--container .spinner.spinner__size-small .spinner--loader {
    width: var(--exo-spacing-large);
    height: var(--exo-spacing-large);
  }

  /** Old Spinner**/

  :host .loader .variant--default .loader--image.spinner {
    border-radius: var(--exo-radius-circle);
    border-top: var(--exo-spacing-2x-small) solid
      var(--exo-color-background-action);
    border-right: var(--exo-spacing-2x-small) solid var(--exo-opacity-0);
    animation: default-animation calc(var(--exo-time-x-slow)) linear infinite;
    box-sizing: border-box;
  }

  @keyframes default-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  #table_grid {
    display: grid;
    width: 100%;
    height: 50%;
  }

  #table_line {
    stroke: var(--exo-color-border);
  }

  #table_item {
    display: flex;
    fill: var(--exo-color-background-action-tertiary-hover);
    border-radius: var(--exo-radius-large);
    animation: skeleton calc(var(--exo-time-x-slow) * 1.5) alternate infinite;
    transition-timing-function: var(--exo-curve-smooth);
  }

  @keyframes skeleton {
    0% {
      fill: var(--exo-color-background-action-tertiary-hover);
    }
    100% {
      fill: var(--exo-color-background-secondary);
    }
  }

  :host .pb--wrapper .pb--main--container {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
  }

  :host .pb--wrapper .pb--main--container .pb--value--section {
    margin-right: var(--exo-spacing-2x-small);
    font: var(--exo-text-label-standard);
    color: var(--exo-color-font-secondary);
  }

  :host .pb--wrapper .pb--main--container .pb--indicator--section {
    width: 100%;
    max-width: var(--exo-size-2);
    padding-bottom: var(--exo-spacing-2x-small);
  }

  :host
    .pb--wrapper.pb-size-medium
    .pb--main--container
    .pb--indicator--section {
    width: 100%;
    max-width: var(--exo-size-3);
  }

  :host
    .pb--wrapper.pb-size-large
    .pb--main--container
    .pb--indicator--section {
    width: 100%;
    max-width: var(--exo-size-4);
    padding-bottom: var(--exo-spacing-2x-small);
  }

  :host
    .pb--wrapper
    .pb--main--container
    .pb--indicator--section
    .pb--label
    div,
  :host .pbl--wrapper .pbl--indicator--section .pbl--label div {
    font: var(--exo-text-label-standard);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :host .pb--wrapper .pb--main--container .pb--main--close--section {
    margin-left: var(--exo-spacing-small);
    font-size: var(--exo-font-size-medium);
  }

  :host .pb--wrapper .pb--indicator--section .pb--label {
    display: flex;
    flex-wrap: nowrap;
    font-size: var(--exo-font-size-2x-large);
  }

  :host .pb--wrapper .pb--indicator--section .pb--label ex-icon {
    color: var(--exo-color-icon-tertiary);
    margin: 0 var(--exo-spacing-2x-small) var(--exo-spacing-2x-small) 0;
  }

  :host .pb--wrapper .pb--error-container {
    display: flex;
  }

  :host .pb--wrapper .pb--indicator {
    width: 100%;
    height: calc(var(--exo-size-1) / 20);
    position: relative;
    overflow: none;
    background: var(--exo-color-border);
    border-radius: var(--exo-radius-standard);
  }

  :host .pb--wrapper .pb--indicator .pb--indicator--dynamic {
    height: calc(var(--exo-size-1) / 20);
    background: var(--exo-color-background-action);
    position: absolute;
    border-radius: var(--exo-radius-standard);
    max-width: 100%;
    min-width: 0;
    transition: var(--exo-time-slow) width;
    width: 0;
  }

  :host .pb--wrapper.pb-size-large .pb--indicator,
  :host .pbl--wrapper.pb-size-large .pbl--indicator {
    height: calc(var(--exo-size-1) / 10);
  }

  :host .pb--wrapper.pb-size-large .pb--indicator .pb--indicator--dynamic,
  :host .pbl--wrapper.pb-size-large .pbl--indicator .pb--indicator--dynamic {
    height: calc(var(--exo-size-1) / 10);
  }

  :host .pb--wrapper.pb-state-completed .pb--indicator {
    border: var(--exo-spacing-3x-small) solid var(--exo-color-outline-weak);
  }

  :host .pb--wrapper.pb-state-completed.pb-size-large .pb--indicator {
    border: var(--exo-spacing-2x-small) solid var(--exo-color-outline-weak);
    border-radius: var(--exo-radius-large);
  }

  :host
    .pb--wrapper.pb-state-completed.pb-size-large
    .pb--indicator
    .pb--indicator--dynamic {
    border-radius: var(--exo-radius-large);
  }

  :host .pb--wrapper.pb-state-completed .pb--indicator .pb--indicator--dynamic,
  :host
    .pbl--wrapper.pb-state-completed
    .pbl--indicator
    .pb--indicator--dynamic {
    width: 100%;
  }

  :host .pb--wrapper.pb-state-completed .pb--value--section,
  :host .pbl--wrapper.pb-state-completed .pb--value--section,
  :host .pbl--wrapper.pb-state-to-start .pb--value--section {
    display: none;
    margin-right: var(--exo-spacing-2x-small);
    font: var(--exo-text-label-standard);
    color: var(--exo-color-font-secondary);
  }

  :host .pb--wrapper .pb--value--section-completed {
    display: none;
  }

  :host .pb--wrapper.pb-state-completed .pb--value--section-completed {
    display: block;
    margin-right: var(--exo-spacing-2x-small);
    font-size: var(--exo-font-size-3x-large);
  }

  :host
    .pb--wrapper.pb-state-completed.pb-size-large
    .pb--value--section-completed {
    margin-right: var(--exo-spacing-x-small);
    font-size: var(--exo-font-size-4x-large);
  }

  :host
    .pb--wrapper.pb-state-completed.pb-size-large
    .pb--main--close--section {
    margin-bottom: 5px;
  }

  :host .pb--wrapper.pb-state-error .pb--indicator {
    display: none;
  }

  :host .pb--wrapper.pb-state-error .pb--error-container ex-icon {
    color: var(--exo-color-icon-danger);
    margin-right: var(--exo-spacing-2x-small);
  }

  :host .pb--wrapper.pb-state-error .pb--error-container div {
    font-size: var(--exo-font-size-micro);
    color: var(--exo-color-font-danger);
  }

  :host .pb--wrapper.pb-state-error .pb--indicator--section {
    max-width: var(--exo-size-2);
    width: calc(100vw - 165px);
    padding: 0;
  }

  :host .pb--wrapper.pb-state-error.pb-size-medium .pb--indicator--section {
    max-width: var(--exo-size-3);
    padding: 0;
    width: calc(100vw - 165px);
  }

  :host .pb--wrapper.pb-state-error.pb-size-large .pb--indicator--section {
    max-width: var(--exo-size-4);
    padding: 0;
    width: calc(100vw - 165px);
  }

  :host
    .pb--wrapper.pb-state-error
    .pb--main--container
    .pb--main--close--section {
    margin-bottom: var(--exo-spacing-2x-small);
    margin-left: var(--exo-spacing-x-small);
    display: flex;
  }

  :host
    .pb--wrapper
    .pb--main--container
    .pb--main--close--section
    .pb--repeat-icon {
    display: none;
  }

  :host
    .pb--wrapper.pb-state-error
    .pb--main--container
    .pb--main--close--section
    .pb--repeat-icon {
    display: block;
    font-size: var(--exo-font-size-large);
    margin-right: var(--exo-spacing-small);
    margin-top: var(--exo-spacing-2x-small);
  }
  :host .clickable__icon {
    cursor: pointer;
  }

  /** PROGRESS STATES CSS **/

  :host .pbl--wrapper .pbl--main--container {
    display: flex;
    align-items: center;
    height: calc(var(--exo-size-1) * 0.4);
    gap: var(--exo-spacing-3x-small);
    padding: var(--exo-spacing-none) var(--exo-spacing-x-small);
    border-radius: calc(var(--exo-radius-small) * 2);
  }

  :host .pbl--wrapper .pbl--main--container .pbl--indicator--section {
    display: flex;
    align-items: center;
    max-width: calc(var(--exo-size-1) * 2);
    gap: var(--exo-spacing-x-small);
    padding: var(--exo-spacing-2x-small);
    width: 100vw;
  }

  :host
    .pbl--wrapper.pb-size-medium
    .pbl--main--container
    .pbl--indicator--section {
    width: 100vw;
    max-width: var(--exo-size-3);
  }

  :host
    .pbl--wrapper.pb-size-large
    .pbl--main--container
    .pbl--indicator--section {
    width: 100vw;
    max-width: var(--exo-size-4);
  }

  :host .pbl--wrapper .pbl--main--container .pbl--main--close--section {
    display: flex;
    gap: var(--exo-spacing-2x-small);
  }

  :host .pbl--wrapper .pbl--indicator--section .pbl--label {
    max-width: calc(var(--exo-size-1) * 1.2);
  }

  :host .pbl--wrapper.pb-size-medium .pbl--indicator--section .pbl--label,
  :host .pbl--wrapper.pb-size-large .pbl--indicator--section .pbl--label {
    max-width: var(--exo-size-2);
  }

  :host .pbl--wrapper .pbl--main--container ex-icon {
    color: var(--exo-color-background-deselected);
  }

  :host .pbl--wrapper .pbl--error-container {
    display: flex;
    gap: var(--exo-spacing-2x-small);
  }

  :host .pbl--wrapper .pbl--indicator {
    width: 100vw;
    height: calc(var(--exo-size-1) / 40);
    position: relative;
    background: var(--exo-color-background-info);
    border-radius: var(--exo-radius-standard);
    max-width: calc(var(--exo-size-1) * 3);
  }

  :host .pbl--wrapper .pbl--indicator .pb--indicator--dynamic {
    height: calc(var(--exo-size-1) / 40);
    background: var(--exo-color-background-selected);
    position: absolute;
    border-radius: var(--exo-radius-standard);
    max-width: 100%;
    min-width: 0;
    transition: var(--exo-time-slow) width;
    width: 0;
  }

  :host .pbl--wrapper.pb-size-large .pbl--indicator {
    max-width: calc(var(--exo-size-1) * 4);
  }

  :host .pbl--wrapper.pb-state-completed .pbl--indicator,
  :host .pbl--wrapper.pb-state-completed .pb--indicator--dynamic {
    background: var(--exo-color-background-success-strong);
  }

  :host .pbl--wrapper.pb-state-completed.pb-size-large .pbl--indicator {
    border-radius: var(--exo-radius-large);
  }

  :host
    .pbl--wrapper:not(.pb-state-error):not(.pb-state-to-start)
    .pb--remove-icon,
  :host .pbl--wrapper:not(.pb-state-completed) .pb--delete-icon,
  :host .pbl--wrapper:not(.pb-state-interrupted) .pb--repeat-icon,
  :host
    .pbl--wrapper:not(.pb-state-in-progress):not(.pb-state-interrupted)
    .pb--cancel-icon {
    display: none;
  }

  :host .pbl--wrapper.pb-state-to-start .pbl--indicator .pb--indicator--dynamic,
  :host .pbl--wrapper.pb-state-error .pbl--indicator .pb--indicator--dynamic {
    background: none;
  }

  :host .pbl--wrapper.pb-state-error .pbl--error-container ex-icon {
    color: var(--exo-color-icon-danger);
  }

  :host .pbl--wrapper.pb-state-interrupted .pb--indicator--dynamic {
    background: var(--exo-color-background-warning-strong);
  }

  :host .pbl--wrapper.pb-state-error .pbl--indicator--section {
    max-width: calc(var(--exo-size-1) * 3);
    width: 100vw;
  }

  :host .pbl--wrapper.pb-state-error.pb-size-medium .pb--indicator--section {
    max-width: var(--exo-size-3);
    width: 100vw;
  }

  :host .pbl--wrapper.pb-state-error.pb-size-large .pbl--indicator--section {
    max-width: var(--exo-size-4);
    width: 100vw;
  }

  :host .pbl--wrapper.pb-state-error .pbl--error-container div {
    width: calc(100vw - (1.75 * var(--exo-size-1)));
    max-width: var(--exo-size-2);
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font-danger);
  }

  :host .pbl--wrapper.pb-state-error.pb-size-medium .pbl--error-container div {
    width: calc(100vw - (1.75 * var(--exo-size-1)));
    max-width: var(--exo-size-3);
  }

  :host .pbl--wrapper.pb-state-error.pb-size-large .pbl--error-container div {
    width: calc(100vw - (1.75 * var(--exo-size-1)));
    max-width: var(--exo-size-4);
  }

  /** PROGRESS BAR STATE**/

  :host .pb-state-to-start .pbl--main--container:hover,
  :host .pb-state-in-progress .pbl--main--container:hover,
  :host .pb-state-interrupted .pbl--main--container:hover,
  :host .pb-state-completed .pbl--main--container:hover,
  :host .pb-state-to-start .pbl--main--container:not(:focus):focus-within,
  :host .pb-state-in-progress .pbl--main--container:not(:focus):focus-within,
  :host .pb-state-interrupted .pbl--main--container:not(:focus):focus-within,
  :host .pb-state-completed .pbl--main--container:not(:focus):focus-within {
    outline: var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);
  }

  :host .pb-state-to-start .pbl--main--container:focus-visible,
  :host .pb-state-in-progress .pbl--main--container:focus-visible,
  :host .pb-state-interrupted .pbl--main--container:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .pb-state-error .pbl--main--container {
    background: var(--exo-color-background-danger-weak);
  }

  :host .pb-state-error .pbl--main--container:hover,
  :host .pb-state-error .pbl--main--container:not(:focus):focus-within {
    outline: var(--exo-spacing-4x-small) solid var(--exo-color-border);
  }

  :host .pb-state-error .pbl--main--container:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .pb-state-completed .pbl--main--container:focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-success-strong);
  }

  /** Footer type **/

  :host .pbl__help-text {
    display: flex;
    gap: var(--exo-spacing-2x-small);
    font: var(--exo-text-label-micro);
    max-width: calc(var(--exo-size-1) * 3);
    padding: var(--exo-spacing-none) var(--exo-spacing-2x-small)
      var(--exo-spacing-2x-small);
  }

  :host .pbl__footer-in-progress,
  :host .pbl__footer-to-start,
  :host .pbl__footer-interrupted {
    color: var(--exo-color-background-info-strong);
  }

  :host .pbl__footer-completed {
    color: var(--exo-color-background-success-strong);
  }

  :host .pbl__footer-interrupted ex-icon {
    color: var(--exo-color-background-warning-strong);
  }
`;
var y = Object.defineProperty, f = Object.getOwnPropertyDescriptor, a = (e, o, s, l) => {
  for (var c, d = l > 1 ? void 0 : l ? f(o, s) : o, h = e.length - 1; h >= 0; h--)
    (c = e[h]) && (d = (l ? c(o, s, d) : c(d)) || d);
  return l && d && y(o, s, d), d;
}, z = ((e) => (e.DEFAULT = "default", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "x-large", e.SQUARE = "square", e.CIRCLE = "circle", e))(z || {}), k = ((e) => (e.DEFAULT = "default", e.SPINNER = "spinner", e.RADAR = "radar", e.SKELETON = "skeleton", e.PROGRESS_BAR = "progress-bar", e.PROGRESS_BAR_COMPACT = "progress-bar-compact", e.GENERAL_LOADER = "general-loader", e.COMPONENT_LEVEL_SMALL = "component-level-small", e.COMPONENT_LEVEL_MEDIUM = "component-level-medium", e))(k || {}), _ = ((e) => (e.TO_START = "to-start", e.INTERRUPTED = "interrupted", e.IN_PROGRESS = "in-progress", e.COMPLETED = "completed", e.ERROR = "error", e))(_ || {}), C = ((e) => (e.XXSMALL = "xx-small", e.XSMALL = "x-small", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e))(C || {}), S = ((e) => (e.INFO = "info", e.SUCCESS = "success", e.ERROR = "error", e.WARNING = "warning", e))(S || {});
class t extends x {
  constructor() {
    super(...arguments), this.size = "default", this.variant = "default", this.backdrop = !1, this.inline = !1, this.label = "", this.value = "", this.color = "dark", this.icon = "", this.errormsg = "", this.state = "in-progress", this.hideCloseIcon = !1, this.hideIcon = !1, this.leadingIcon = "", this.helpText = "", this.spinnerSize = "medium", this.showActions = !1, this.leadingIconLabel = "", this.radarSvg = r`<div class="loader--image">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      style="margin: auto; display: block;"
      viewBox="0 0 72 72"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="36"
        cy="36"
        r="0"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2s"
          values="0;36"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="2s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
      </circle>

      <circle
        cx="36"
        cy="36"
        r="0"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2s"
          values="0;36"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="1s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="2s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="1s"
        ></animate>
      </circle>
    </svg>
  </div>`, this.spinnerLoader = () => r`
    <div
      class=${p({ "loader--container": !0, "loader--backdrop": this.backdrop, "loader--inline": this.inline })}
    >
      <div
        class=${p({ spinner: !0, [this.getSpinnerSizeClassName()]: !0 })}
      >
        <div
          class=${p({ "loader__variant-spinner": !0, "variant--spinner": this.variant === "spinner" })}
        >
          ${this.getSpinnerVariant()}
        </div>
        ${this.getLabel()}
      </div>
    </div>
  `, this.defaultLoader = () => r`
    <div
      class=${p({ "loader--container": !0, "loader--backdrop": this.backdrop, "loader--inline": this.inline })}
    >
      <div
        class=${p({ loader: !0, "loader--default": this.size === "default", "loader--small": this.size === "small", "loader--medium": this.size === "medium", "loader--large": this.size === "large" })}
      >
        <div
          class=${p({ "loader__variant-spinner": !0, "variant--default": this.variant === "default", "variant--radar": this.variant === "radar" })}
        >
          ${this.getDefaultVariant()}
          ${this.variant === "radar" ? this.radarSvg : n}
        </div>
        ${this.getLabel()}
      </div>
    </div>
  `, this.inComponentLoader = () => r`
    <div
      class=${p({ "loader--comp--container": !0, "loader--in--component-medium": this.variant === "component-level-medium", "loader--in--component-small": this.variant === "component-level-small", "loader--color--theme--dark": this.color === "dark", "loader--color--theme--light": this.color === "light" })}
    >
      <div class="spinner loader--image"></div>
    </div>
  `, this.progressBarCompact = () => r`
    <div
      class=${p({ "pbl--wrapper": !0, [this.getStateClassName()]: !0 })}
    >
      <div class="pbl--indicator--section">
        <div class="pbl--indicator">${this.getIndicator()}</div>
      </div>
      ${this.renderFooterContent()}
    </div>
  `, this.progressBar = () => r`
    <div
      class=${p({ "pbl--wrapper": !0, [this.getStateClassName()]: !0, [this.getSizeClassName()]: !0 })}
      role="progressbar"
      aria-label=${this.getAriaLabel()}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-valuenow=${this.value}
    >
      <div class="pbl--main--container" tabindex="0">
        ${this.getIcon()}
        <div class="pbl--indicator--section">
          <div class="pbl--label">
            <div>${this.label}</div>
          </div>
          <div class="pbl--indicator">${this.getIndicator()}</div>
        </div>

        <div class="pbl--main--close--section">
          ${this.getRetryIcon()} ${this.getRemoveIcon()}${this.getDeleteIcon()}
          ${this.getCloseIcon()}
        </div>
      </div>
      ${this.renderFooterContent()}
    </div>
  `;
  }
  getDefaultVariant() {
    return this.variant === "default" ? r`<div class="spinner loader--image"></div>` : n;
  }
  getSpinnerVariant() {
    return this.variant === "spinner" ? r`<div class="spinner spinner--loader"></div>` : n;
  }
  getLabel() {
    return this.label ? r`<div class="loader--body">${this.label}</div>` : n;
  }
  getSpinnerSizeClassName() {
    return `spinner__size-${this.spinnerSize}`;
  }
  dispatchCustomEvent(o) {
    const s = new CustomEvent(o, { bubbles: !0, cancelable: !1, composed: !0, detail: {} });
    this.dispatchEvent(s);
  }
  handleClose() {
    this.dispatchCustomEvent("onClose");
  }
  handleRepeat() {
    this.dispatchCustomEvent("onRestart");
  }
  getErrorMessage() {
    return this.errormsg.length ? this.errormsg : r`Error`;
  }
  getStateClassName() {
    return `pb-state-${this.state}`;
  }
  getSizeClassName() {
    return `pb-size-${this.size}`;
  }
  getAriaLabel() {
    return this.label.length > 0 ? this.label : "progress";
  }
  getValueSection() {
    return this.value && this.state !== "error" ? r`<div class="pb--value--section" aria-live="polite">
        (${this.value}%)
      </div>` : n;
  }
  getIcon() {
    return this.hideIcon ? n : r`<ex-icon
      size="XS"
      icon=${this.leadingIcon}
      label=${this.leadingIconLabel}
    ></ex-icon>`;
  }
  getWidthStyle() {
    return v({ width: `${this.value}%` });
  }
  getIndicator() {
    return this.value ? r`<div
        class="pb--indicator--dynamic"
        style=${this.getWidthStyle()}
      ></div>` : r`<div class="pb--indicator--dynamic"></div>`;
  }
  getRetryIcon() {
    return this.showActions ? r` <ex-icon-button
        class="clickable__icon pb--repeat-icon"
        icon="Retry"
        flavor="branded"
        type="tertiary"
        tooltiptext="Retry"
        hide-browser-tooltip
        size="small"
        @click=${this.handleRepeat}
      ></ex-icon-button>` : n;
  }
  getRemoveIcon() {
    return this.showActions ? r` <ex-icon-button
        class="clickable__icon pb--remove-icon"
        icon="Minus"
        flavor="branded"
        type="tertiary"
        tooltiptext="Remove"
        hide-browser-tooltip
        size="small"
        @click=${this.handleClose}
      ></ex-icon-button>` : n;
  }
  getDeleteIcon() {
    return this.showActions ? r` <ex-icon-button
        class="clickable__icon pb--delete-icon"
        icon="Delete"
        flavor="branded"
        type="tertiary"
        tooltiptext="Delete"
        hide-browser-tooltip
        size="small"
        @click=${this.handleClose}
      ></ex-icon-button>` : n;
  }
  getCloseIcon() {
    return this.hideCloseIcon || this.showActions ? r` <ex-icon-button
        class="clickable__icon pb--cancel-icon"
        icon="Close"
        flavor="branded"
        type="tertiary"
        tooltiptext="Cancel"
        hide-browser-tooltip
        size="small"
        @click=${this.handleClose}
      ></ex-icon-button>` : n;
  }
  getFooterType(o) {
    return this.helpText ? r`<div class="pbl__help-text">
        ${function(s) {
      let l;
      switch (s) {
        case "info":
        default:
          l = "Information";
          break;
        case "success":
          l = "Success";
          break;
        case "warning":
          l = "Warning";
      }
      return r`<ex-icon size="XS" icon=${l}></ex-icon>`;
    }(o)}${this.helpText}${this.getValueSection()}
      </div>` : n;
  }
  renderFooterContent() {
    let o;
    switch (this.state) {
      case "completed":
        o = this.getFooterType("success");
        break;
      case "to-start":
      case "in-progress":
        o = this.getFooterType("info");
        break;
      case "interrupted":
        o = this.getFooterType("warning");
        break;
      case "error":
        o = this.getErrorSection();
        break;
      default:
        o = n;
    }
    return r`<span class="pbl__footer-${this.state}"
      >${o}</span
    >`;
  }
  getErrorSection() {
    return r`<div class="pbl--error-container">
      <ex-icon size="XS" icon="Error"></ex-icon>
      <div aria-live="polite">${this.getErrorMessage()}</div>
    </div>`;
  }
  getErrorMessageSection() {
    return this.state === "error" ? r`<div class="pb--error-container">
        <ex-icon size="XS" icon="Error"></ex-icon>
        <div aria-live="polite">${this.getErrorMessage()}</div>
      </div>` : n;
  }
  render() {
    switch (this.variant) {
      case "component-level-small":
      case "component-level-medium":
        return this.inComponentLoader();
      case "skeleton":
        return r`
  <div
    style="display: inline-flex; width: 100%; justify-content: flex-start;
align-items: flex-start;"
  >
    <svg
      id="table_grid"
      width="100%"
      height="100%"
      viewBox="0 0 880 768"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect id="table_item" width="880" height="48" rx="10" />
      <g id="table_item">
        <rect y="72" width="120" height="32" rx="10" />
        <rect x="152" y="72" width="120" height="32" rx="10" />
        <rect x="304" y="72" width="120" height="32" rx="10" />
        <rect x="456" y="72" width="120" height="32" rx="10" />
        <rect x="608" y="72" width="120" height="32" rx="10" />
        <rect x="760" y="72" width="120" height="32" rx="10" />
      </g>
      <line y1="119.5" x2="880" y2="119.5" id="table_line" />
      <g id="table_item">
        <rect y="144" width="120" height="32" rx="10" />
        <rect x="152" y="144" width="120" height="32" rx="10" />
        <rect x="304" y="144" width="120" height="32" rx="10" />
        <rect x="456" y="144" width="120" height="32" rx="10" />
        <rect x="608" y="144" width="120" height="32" rx="10" />
        <rect x="760" y="144" width="120" height="32" rx="10" />
      </g>
      <line y1="191.5" x2="880" y2="191.5" id="table_line" />
      <g id="table_item">
        <rect y="216" width="120" height="32" rx="10" />
        <rect x="152" y="216" width="120" height="32" rx="10" />
        <rect x="304" y="216" width="120" height="32" rx="10" />
        <rect x="456" y="216" width="120" height="32" rx="10" />
        <rect x="608" y="216" width="120" height="32" rx="10" />
        <rect x="760" y="216" width="120" height="32" rx="10" />
      </g>
      <line y1="263.5" x2="880" y2="263.5" id="table_line" />
      <g id="table_item">
        <rect y="288" width="120" height="32" rx="10" />
        <rect x="152" y="288" width="120" height="32" rx="10" />
        <rect x="304" y="288" width="120" height="32" rx="10" />
        <rect x="456" y="288" width="120" height="32" rx="10" />
        <rect x="608" y="288" width="120" height="32" rx="10" />
        <rect x="760" y="288" width="120" height="32" rx="10" />
      </g>
      <line y1="335.5" x2="880" y2="335.5" id="table_line" />
      <g id="table_item">
        <rect y="360" width="120" height="32" rx="10" />
        <rect x="152" y="360" width="120" height="32" rx="10" />
        <rect x="304" y="360" width="120" height="32" rx="10" />
        <rect x="456" y="360" width="120" height="32" rx="10" />
        <rect x="608" y="360" width="120" height="32" rx="10" />
        <rect x="760" y="360" width="120" height="32" rx="10" />
      </g>
      <line y1="407.5" x2="880" y2="407.5" id="table_line" />
      <g id="table_item">
        <rect y="432" width="120" height="32" rx="10" />
        <rect x="152" y="432" width="120" height="32" rx="10" />
        <rect x="304" y="432" width="120" height="32" rx="10" />
        <rect x="456" y="432" width="120" height="32" rx="10" />
        <rect x="608" y="432" width="120" height="32" rx="10" />
        <rect x="760" y="432" width="120" height="32" rx="10" />
      </g>
      <line y1="479.5" x2="880" y2="479.5" id="table_line" />
      <g id="table_item">
        <rect y="504" width="120" height="32" rx="10" />
        <rect x="152" y="504" width="120" height="32" rx="10" />
        <rect x="304" y="504" width="120" height="32" rx="10" />
        <rect x="456" y="504" width="120" height="32" rx="10" />
        <rect x="608" y="504" width="120" height="32" rx="10" />
        <rect x="760" y="504" width="120" height="32" rx="10" />
      </g>
      <line y1="551.5" x2="880" y2="551.5" id="table_line" />
      <g id="table_item">
        <rect y="576" width="120" height="32" rx="10" />
        <rect x="152" y="576" width="120" height="32" rx="10" />
        <rect x="304" y="576" width="120" height="32" rx="10" />
        <rect x="456" y="576" width="120" height="32" rx="10" />
        <rect x="608" y="576" width="120" height="32" rx="10" />
        <rect x="760" y="576" width="120" height="32" rx="10" />
      </g>
      <line y1="623.5" x2="880" y2="623.5" id="table_line" />
      <g id="table_item">
        <rect y="648" width="120" height="32" rx="10" />
        <rect x="152" y="648" width="120" height="32" rx="10" />
        <rect x="304" y="648" width="120" height="32" rx="10" />
        <rect x="456" y="648" width="120" height="32" rx="10" />
        <rect x="608" y="648" width="120" height="32" rx="10" />
        <rect x="760" y="648" width="120" height="32" rx="10" />
      </g>
      <line y1="695.5" x2="880" y2="695.5" id="table_line" />
      <g id="table_item">
        <rect y="720" width="120" height="32" rx="10" />
        <rect x="152" y="720" width="120" height="32" rx="10" />
        <rect x="304" y="720" width="120" height="32" rx="10" />
        <rect x="456" y="720" width="120" height="32" rx="10" />
        <rect x="608" y="720" width="120" height="32" rx="10" />
        <rect x="760" y="720" width="120" height="32" rx="10" />
      </g>
      <line y1="767.5" x2="880" y2="767.5" id="table_line" />
    </svg>
  </div>
`;
      case "spinner":
        return this.spinnerLoader();
      case "progress-bar":
        return this.progressBar();
      case "progress-bar-compact":
        return this.progressBarCompact();
      case "general-loader":
        return ((o) => {
          let s;
          switch (this.size) {
            case "default":
              s = r`
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 880 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 15px;
      border-radius: var(--exo-radius-standard);"
        >
          <rect id="table_item" width="880" height="16" fill="#CCCCCC" />
        </svg>
      `;
              break;
            case "small":
              s = r`
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 880 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 15px;
          border-radius: var(--exo-radius-standard);"
        >
          <rect id="table_item" width="880" height="32" fill="#CCCCCC" />
        </svg>
      `;
              break;
            case "medium":
              s = r`
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 15px;
          border-radius: var(--exo-radius-standard);"
        >
          <rect id="table_item" width="880" height="48" fill="#CCCCCC" />
        </svg>
      `;
              break;
            case "large":
              s = r`
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 880 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 15px;
          border-radius: var(--exo-radius-standard);"
        >
          <rect id="table_item" width="880" height="64" fill="#CCCCCC" />
        </svg>
      `;
              break;
            case "x-large":
              s = r`
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 880 272"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 15px;
          border-radius: calc(var(--exo-radius-small)*4);"
        >
          <rect id="table_item" width="880" height="272" fill="#CCCCCC" />
        </svg>
      `;
              break;
            case "circle":
              s = r`
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="border-radius: var(--exo-radius-circle);"
        >
          <rect
            id="table_item"
            x="0.5"
            y="0.5"
            width="100%"
            height="37"
            fill="#CCCCCC"
          />
        </svg>
      `;
              break;
            case "square":
              s = r`
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 880 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-bottom: 15px;
          border-radius: var(--exo-radius-standard);"
        >
          <rect
            id="table_item"
            x="0.5"
            y="0.5"
            width="880"
            height="37"
            fill="#CCCCCC"
          />
        </svg>
      `;
          }
          return r`
    <div
      style="display: inline-flex; width: 100%; justify-content: flex-start;
align-items: flex-start;"
    >
      ${s}
    </div>
  `;
        })();
      default:
        return this.defaultLoader();
    }
  }
}
t.styles = u, a([i()], t.prototype, "size", 2), a([i()], t.prototype, "variant", 2), a([i({ type: Boolean })], t.prototype, "backdrop", 2), a([i({ type: Boolean })], t.prototype, "inline", 2), a([i()], t.prototype, "label", 2), a([i()], t.prototype, "value", 2), a([i()], t.prototype, "color", 2), a([i()], t.prototype, "icon", 2), a([i()], t.prototype, "errormsg", 2), a([i()], t.prototype, "state", 2), a([i({ type: Boolean })], t.prototype, "hideCloseIcon", 2), a([i({ type: Boolean })], t.prototype, "hideIcon", 2), a([i()], t.prototype, "leadingIcon", 2), a([i({ attribute: "help-text" })], t.prototype, "helpText", 2), a([i()], t.prototype, "spinnerSize", 2), a([i({ type: Boolean })], t.prototype, "showActions", 2), a([i({ type: String })], t.prototype, "leadingIconLabel", 2);
const T = (e = "") => {
  g("ex-loader", t, e), w(e), m(e);
};
export {
  z as L,
  C as S,
  k as a,
  _ as b,
  t as c,
  S as d,
  T as r
};
